module.exports = __webpack_public_path__ + "static/media/help.2baff86b.svg";